import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { Spin } from "antd";
import { BrowserRouter } from "react-router-dom";

import "./index.css";
import "./locale/i18n";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import keycloak from "@utils/keycloak";

import "antd/dist/reset.css";

const rootElement = document.getElementById("root") as HTMLElement;

const root = createRoot(rootElement);

keycloak
  .init({
    checkLoginIframe: false,
  })
  .then(() => {
    root.render(
      <React.StrictMode>
        <Suspense fallback={<Spin size="large" className="loading" />}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Suspense>
      </React.StrictMode>
    );
  })
  .catch((err) => console.log("err catch:>> ", err));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals.
reportWebVitals();
